/* global System */
// register component(s) with react habitat

export default { SectionNav: () => System.import('./index') }
